import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    standalone: false
})
export class ChangePasswordFormComponent {
  @Input() form!: UntypedFormGroup;
  @Input() showErrors!: boolean;
  @Input() errorsList!: { [controlId: string]: { [errorKey: string]: string } };

  constructor() {}

  get currentPasswordControl(): UntypedFormControl {
    return this.form.get('currentPassword') as UntypedFormControl;
  }

  get newPasswordControl(): UntypedFormControl {
    return this.form.get('newPassword') as UntypedFormControl;
  }

  get confirmPasswordControl(): UntypedFormControl {
    return this.form.get('confirmPassword') as UntypedFormControl;
  }
}
